module.exports = __webpack_public_path__ + "static/img/089_TO8_1751_og.52f6c1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/089_TO8_1751_og.jpg
// module id = /Q/Y
// module chunks = 0